import { useModules } from "@/auth/ModulesContext";

/** Resolved, not optimistic: hasModule says true while loading, which would fire WhatsApp reads that 403. */
export function useWhatsAppEnabled(): boolean {
  const { hasModule, modules } = useModules();
  return modules !== null && hasModule("whatsapp");
}
